var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.logo },
    [
      _vm.isTabletLandscapeUp
        ? _c("svgLogo", { attrs: { width: "178" } })
        : _c("svgLogoRound", { attrs: { width: "30" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }